/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBrowser} from '@fortawesome/pro-duotone-svg-icons';

const WebPageIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBrowser} {...props} />
);

export default WebPageIcon;
